import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";
import CloseIcon from "@components/Icons/CloseIcon";
import "./style.scss";

const Drawer = ({
                    isOpen,
                    onClose,
                    children,
                    closeButtonAlignment,
                    additionalClasses = "",
                    showBackdrop = true,
                    usePortal = true,
                    id,
                    role = "dialog",
                    "aria-modal": ariaModal = "true",
                    "aria-label": ariaLabel
                }) => {

    const location = useLocation();
    const prevPathRef = useRef(location.pathname);
    const isOpenRef = useRef(isOpen);
    isOpenRef.current = isOpen;

    useEffect(() => {
        if (prevPathRef.current !== location.pathname) {
            prevPathRef.current = location.pathname;
            if (isOpenRef.current) {
                onClose();
            }
        }
    }, [location.pathname, onClose]);

    const content = (
        <>
            <div
                id={id}
                role={role}
                aria-modal={ariaModal}
                aria-label={ariaLabel}
                aria-hidden={!isOpen}
                className={`drawer ${isOpen ? `open ${additionalClasses}` : ""}`}
            >
                <div className="drawer__content">
                    <button
                        className={`drawer__close drawer__close--${closeButtonAlignment}`}
                        onClick={onClose}
                        aria-label="Close drawer"
                    >
                        <CloseIcon className="drawer__svg" />
                    </button>
                    {children}
                </div>
            </div>
            {isOpen && showBackdrop && (
                <div
                    role="presentation"
                    className="backdrop open"
                    onClick={onClose}
                ></div>
            )}
        </>
    );

    return usePortal ? ReactDOM.createPortal(content, document.body) : content;
};

export default Drawer;
